export type CustomerType = 'direct' | 'marketplace';

export const determineCustomerType = (): CustomerType => {
    // Check URL parameters for marketplace indicators first
    const urlParams = new URLSearchParams(window.location.search);
    const marketplaceParam = urlParams.get('marketplace');
    const source = urlParams.get('source');
    
    // Check for explicit marketplace parameters
    if (marketplaceParam === 'aws' || source === 'aws-marketplace') {
        return 'marketplace';
    }
    
    // Check referrer for AWS marketplace (but exclude localhost/development)
    const referrer = document.referrer;
    if (referrer && 
        referrer.includes('aws.amazon.com') && 
        !referrer.includes('localhost') && 
        !referrer.includes('127.0.0.1')) {
        return 'marketplace';
    }
    
    // Default to direct customer
    return 'direct';
};

export const isMarketplaceCustomer = (): boolean => {
    return determineCustomerType() === 'marketplace';
};

export const isDirectCustomer = (): boolean => {
    return determineCustomerType() === 'direct';
};
